import {Discount} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class DiscountModel {
  public name: string;

  constructor(params: DiscountModel) {
    this.name = params.name;
  }

  public static fromCartV1(name: string) {
    return new DiscountModel({name});
  }

  public static fromCartV2(discount: Discount): DiscountModel {
    return new DiscountModel({name: discount.name.translated});
  }
}
